import { StripeCardNumberElement } from '@stripe/stripe-js';
import { calculateRepaymentRole } from '../../../api/lendingAPI/PaymentAPIHelper';
import { mergeStates } from '../../../iwProvider/StoreHelper';
import {
    clearStripeError,
    handlePaymentMethodErrors,
    handleStripeFieldComplete
} from '../../../iwStripeProvider/StripeHelper';
import {
    AUTHENTICATION_FAILED,
    BANK_ACCOUNT_FUNDING_REQUIREMENT_COMPLETED,
    DEBIT_CARD_FUNDING_REQUIREMENT_COMPLETED,
    SAVE_CARD_NUMBER_ELEMENT,
    SELECT_REPAYMENT_ROLE,
    CHOOSE_PAYMENT_METHOD,
    CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT,
    CHOOSE_PAYMENT_METHOD_DEBIT_CARD,
    CLEAR_STRIPE_ERROR,
    HANDLE_3DS_AUTHENTICATION,
    REGISTER_BANK_ACCOUNT_FAIL,
    REGISTER_BANK_ACCOUNT_PENDING,
    REGISTER_DEBIT_CARD_PENDING,
    CARD_TYPE_NOT_DEBIT,
    RESET_PAYMENT_METHOD,
    SHOW_STRIPE_BRAND,
    SHOW_STRIPE_ERROR,
    STRIPE_FIELD_COMPLETE
} from './AddPaymentMethodModal.actions';
import { GetPaymentMethodResponse } from '@iwoca/lapi-client/edge';

const initialState = {
    invalidCardType: null,
    invalidCard: null,
    invalidNumber: null,
    invalidExpiryDate: null,
    invalidCVV: null,
    invalidPostcode: null,
    repaymentRole: null,
    preSelectedRepaymentRole: null,
    registerCardStatus: null,
    registerBankAccountStatus: null,
    requiresAuthentication: false,
    authenticationFailed: false,
    authenticationIframeURL: null,
    ready: false,
    linkingBankAccount: false
};

type TAction = {
    type?: string;
    repaymentRole?: string;
    errors?: any;
    payment_method?: GetPaymentMethodResponse['data'];
    authenticationIframeURL?: string;
    cardNumberElement?: StripeCardNumberElement;
    brand?: string;
    field?: string;
};

// eslint-disable-next-line import/no-default-export
export default function (
    state = mergeStates(initialState),
    action: TAction = {}
) {
    switch (action.type) {
        case REGISTER_BANK_ACCOUNT_PENDING:
            return mergeStates(state, {
                linkingBankAccount: true
            });

        case SELECT_REPAYMENT_ROLE:
            return mergeStates(state, {
                repaymentRole: action.repaymentRole
            });

        case REGISTER_BANK_ACCOUNT_FAIL:
            return mergeStates(state, {
                linkingBankAccount: false,
                registerBankAccountStatus: 'error'
            });

        case SHOW_STRIPE_ERROR:
            return mergeStates(state, handlePaymentMethodErrors(action.errors));

        case CLEAR_STRIPE_ERROR:
            // @ts-expect-error target function not in TS
            return mergeStates(state, clearStripeError(action));

        case SHOW_STRIPE_BRAND:
            return mergeStates(state, {
                cardBrand: action.brand
            });

        case REGISTER_DEBIT_CARD_PENDING:
            return mergeStates(state, {
                linkingDebitCard: true
            });

        case CARD_TYPE_NOT_DEBIT:
            return mergeStates(
                state,
                {
                    invalidCardType: true,
                    linkingDebitCard: false,
                    authenticationFailed: false
                },
                // @ts-expect-error target function not in TS
                clearStripeError(action)
            );

        case STRIPE_FIELD_COMPLETE:
            // @ts-expect-error target function not in TS
            return mergeStates(state, handleStripeFieldComplete(action));

        case CHOOSE_PAYMENT_METHOD:
            return mergeStates(state, {
                paymentMethodType: ''
            });

        case CHOOSE_PAYMENT_METHOD_DEBIT_CARD:
            return mergeStates(state, {
                paymentMethodType: 'DEBIT_CARD',
                linkingDebitCard: false,
                requiresAuthentication: false,
                authenticationFailed: false,
                preSelectedRepaymentRole: calculateRepaymentRole(
                    action.payment_method!
                )
            });

        case CHOOSE_PAYMENT_METHOD_BANK_ACCOUNT:
            return mergeStates(state, {
                paymentMethodType: 'BANK_ACCOUNT'
            });

        case RESET_PAYMENT_METHOD:
            return mergeStates(initialState);

        case DEBIT_CARD_FUNDING_REQUIREMENT_COMPLETED:
            return mergeStates(state, {
                registerCardStatus: 'success',
                linkingDebitCard: false
            });
        case BANK_ACCOUNT_FUNDING_REQUIREMENT_COMPLETED:
            return mergeStates(state, {
                registerBankAccountStatus: 'success',
                linkingDebitCard: false
            });
        case HANDLE_3DS_AUTHENTICATION:
            return mergeStates(state, {
                requiresAuthentication: true,
                authenticationIframeURL: action.authenticationIframeURL
            });
        case AUTHENTICATION_FAILED:
            return mergeStates(state, {
                requiresAuthentication: false,
                linkingDebitCard: false,
                authenticationFailed: true
            });
        case SAVE_CARD_NUMBER_ELEMENT:
            return mergeStates(state, {
                cardNumberElement: action.cardNumberElement
            });

        default:
            return state;
    }
}
